export const setUserDefaultPlan = (plan) => {
    localStorage.setItem("defaultPlan", plan);
}

export const getUserDefaultPlan = () => {
    return localStorage.getItem("defaultPlan");
}